export default {
  "content": "<path d=\"M15.92 2.78c-1.46-.84-2.93-.87-4.01-.7-.9.14-1.73.58-2.38 1.25L7.44 5.48l-1.4 1.44-2.01 2.07c-.05.05-.08.12-.09.2l-.06 1.09c-.01.09.02.17.08.23l.69.71-.7.72-.46-.48a.32.32 0 00-.46 0l-.93.96c-.13.13-.13.35 0 .48l3.02 3.11c.13.13.34.13.46 0l.93-.96c.13-.13.13-.35 0-.48l-.46-.48.7-.72.75.77c.06.07.16.1.25.09l.99-.13c.06-.01.13-.04.17-.09l1.79-1.84 9.29 10.52c.38.4 1.01.4 1.39 0l1.34-1.38c.38-.4.38-1.04 0-1.44l-10.18-9.6 1.8-1.85c.05-.05.08-.12.09-.19l.1-1.06a.272.272 0 00-.09-.24l-1.91-1.97c1.19-.77 2.24-1.02 3.24-1.08.55-.02.67-.8.15-1.1z\" fill=\"#3F4450\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};